import React from 'react'
import TestimonialCard from './TestimonialCard'
import TestimonialData from '../Data/Testimonial';

const Testimonial = () => {
    return (
        <div>
            <ul className="list__review">
                {TestimonialData.map((item) =>
                    <React.Fragment key={`${item.name}-${item.date}`}>
                        <TestimonialCard data={item} />
                    </React.Fragment>
                )}
            </ul>
        </div>
    )
}

export default Testimonial
